import config from '../config';
import fetch from 'cross-fetch';
import store from 'store2';
import { loadArchiveQuotes, loadArchiveTasks, loadArchiveTasksFailed, reopenArchiveTask, loadArchiveQuotesFailed } from '../actions/archive';
import { push } from 'react-router-redux';

export function getListOfTasks(limits) {
  return dispatch => {
    const userAuth = store.get('user');
    return fetch(`${config.apiEndpoint}/archive/tasks`, {
        method: 'POST',
        body: JSON.stringify(limits),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
      .then((response) => {
        return response.json();
      })
      .then(json => {
        if (json) {
          dispatch(loadArchiveTasks({ list: json.tasks , count: json.count}));
        }
      })
      .catch(response => dispatch(loadArchiveTasksFailed({error: response})));
  }
}

export function getListOfQuotes(filter) {
  return dispatch => {
    const userAuth = store.get('user');
    return fetch(`${config.apiEndpoint}/archive/quotes`, {
        method: 'POST',
        body: JSON.stringify(filter),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
      .then((response) => {
        return response.json();
      })
      .then(json => {
        if (json) {
          dispatch(loadArchiveQuotes({ list: json }));
        }
      })
      .catch(response => dispatch(loadArchiveQuotesFailed({error: response})));
  }
}

export function renewArchiveTask(data) {
  return dispatch => {
    const userAuth = store.get('user');
    return fetch(`${config.apiEndpoint}/taskClock/getProject/${data.id}`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
      .then((response) => {
        return response.json();
      })
      .then(json => {
          dispatch(reopenArchiveTask(json));
      })
  }
}



// WEBPACK FOOTER //
// ./src/api/archive.js